import * as React from "react";
import type { SVGProps } from "react";
export const SvgMiscSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.688 11.815a5.08 5.08 0 0 1 0-10.16 5.08 5.08 0 0 1 0 10.16Zm5.288-.973a6.629 6.629 0 0 0 1.438-4.146C13.414 2.998 10.401 0 6.707 0 3.013.02 0 3.017 0 6.715c0 3.699 3.013 6.696 6.688 6.696a6.775 6.775 0 0 0 4.14-1.44L14.854 16 16 14.852l-4.024-4.01Z"
      clipRule="evenodd"
    />
  </svg>
);
